var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM7.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1a1 1 0 0 1 1-1h3.27a1 1 0 0 1 .98.8L5.91 4H18.5a1 1 0 0 1 .98 1.2l-1.3 6.71a2.6 2.6 0 0 1-.95 1.52c-.48.38-1.07.58-1.68.57H8.1c-.6 0-1.2-.2-1.68-.57a2.6 2.6 0 0 1-.94-1.52L4.12 5.24a1 1 0 0 1-.02-.08L3.46 2H1a1 1 0 0 1-1-1Zm6.32 5 1.13 5.51c.02.14.1.26.21.35.12.1.27.14.42.14H15.57c.16 0 .3-.05.42-.14a.6.6 0 0 0 .22-.34L17.29 6H6.32Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.5392bc3e6384fc2bd4cce5a9f850166c.svg";
export { ForwardRef as ReactComponent };